export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15099.81aebff9.jpg";